import dayjs from 'dayjs';
import { Formik, Form } from 'formik';
import React, { useState } from 'react';

import { Grid } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';

import { Autocomplete, Button, TextField } from 'shared';
import { activityFiltersStyles } from 'components/Inventory/style/style';
import { matchedSchema, matchedInitialValues } from 'components/Inventory/utils/matchedSchema';

const RefundMatchedFilters = ({ banks, users, selected, setSelected, handleFiltersSubmit }) => {
    const classes = activityFiltersStyles({});
    const handleClearClick = (handleReset) => {
        handleReset();
        setSelected([]);
        handleFiltersSubmit({ type: 'not_refund' });
    };

    const handleFormSubmit = (values) => {
        setSelected([]);
        const filters = {
            ...values,
            startDate: values.startDate ? dayjs(values.startDate).format('YYYY-MM-DD') : null,
            endDate: values.endDate ? dayjs(values.endDate).format('YYYY-MM-DD') : null,
            status: values.status?.value,
            type: 'not_refund',
            bankAccount: values.bankAccount?.value,
            matchedBy: values.matchedBy?.value,
        };
        handleFiltersSubmit(filters);
    };

    return (
        <Formik
            onSubmit={handleFormSubmit}
            validationSchema={matchedSchema}
            initialValues={matchedInitialValues}
        >
            {({ values, handleReset, handleChange, setFieldValue }) => {
                return (
                    <Form>
                        <Grid container spacing={1}>
                            <Grid item xs={6} md={4} lg={3}>
                                <Autocomplete
                                    options={banks}
                                    labelKey="label"
                                    valueKey="value"
                                    placeholder="Bank Account"
                                    name="bankAccount"
                                    inlineLabel="Bank Account"
                                    value={values.bankAccount}
                                    onChange={(e, value) => setFieldValue('bankAccount', value)}
                                    isSearchField={false}
                                    disableClearable
                                    customStyle={classes.dropdown}
                                    showTotal={true}
                                />
                            </Grid>

                            <Grid item xs={10} md={4} lg={4} />

                            <Grid item xs={12} />

                            <Grid item xs={4} md={2} lg={2}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        value={values.startDate && dayjs(values.startDate)}
                                        onChange={(date) => setFieldValue('startDate', date)}
                                        label="Start Date"
                                        placeholder="Start Date"
                                        format="MM-DD-YYYY"
                                        sx={classes.datePicker}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={4} md={2} lg={2}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        value={values.endDate && dayjs(values.endDate)}
                                        onChange={(date) => setFieldValue('endDate', date)}
                                        label="End Date"
                                        placeholder="End Date"
                                        format="MM-DD-YYYY"
                                        sx={classes.datePicker}
                                    />
                                </LocalizationProvider>
                            </Grid>

                            <Grid item xs={4} md={2} lg={2}>
                                <TextField
                                    fullWidth
                                    name="amount"
                                    inlineLabel="Amount"
                                    value={values.amount}
                                    placeholder="Search by amount"
                                    customStyle={classes.inputField}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        if (/^-?\d*\.?\d*$/.test(val)) {
                                            handleChange(e);
                                        }
                                    }}
                                />
                            </Grid>

                            <Grid item xs={4} md={2} lg={2}>
                                <TextField
                                    fullWidth
                                    name="description"
                                    inlineLabel="Description"
                                    value={values.description}
                                    placeholder="Search in inventory or bank descriptions"
                                    onChange={handleChange}
                                    customStyle={classes.inputField}
                                />
                            </Grid>

                            <Grid item xs={4} md={2} lg={2}>
                                <Autocomplete
                                    options={users}
                                    labelKey="label"
                                    valueKey="value"
                                    placeholder="User"
                                    name="matchedBy"
                                    inlineLabel="User"
                                    value={values.matchedBy}
                                    onChange={(e, value) => setFieldValue('matchedBy', value)}
                                    isSearchField={false}
                                    disableClearable
                                    customStyle={classes.dropdown}
                                    showTotal={true}
                                />
                            </Grid>

                            <Grid item xs={6} md={2} lg={2}>
                                <TextField
                                    fullWidth
                                    name="referenceId"
                                    inlineLabel="Reference"
                                    value={values.referenceId}
                                    placeholder="Search by reference"
                                    onChange={handleChange}
                                    customStyle={classes.inputField}
                                />
                            </Grid>
                        </Grid>

                        <Grid container marginTop={0.5} marginBottom={1.5}>
                            <Grid item display="flex" gap={2}>
                                <Button
                                    text="Clear"
                                    onClick={() => handleClearClick(handleReset)}
                                    customStyles={classes.cancelButton}
                                />

                                <Button type="submit" text="Apply" variant="contained" />
                            </Grid>
                        </Grid>
                    </Form>
                );
            }}
        </Formik>
    );
};

export default RefundMatchedFilters;
